import { LockOpenIcon } from '@/components/plan-locks/LockOpenIcon';
import { motion, useReducedMotion } from 'framer-motion';
import { Lock } from 'iconoir-react';

/** How long the opening padlock plays before the unlocked state settles. */
export const UNLOCK_SETTLE_MS = 380;

/**
 * The padlock of the unlock button: closed, then open with a short swing of
 * the shackle once the profile is unlocked. Under prefers-reduced-motion the
 * open padlock appears as it is, without moving.
 */
export const UnlockPadlock = ({ open, size = 16 }: { open: boolean; size?: number }) => {
  const reducedMotion = useReducedMotion();

  if (!open) return <Lock width={size} height={size} aria-hidden data-padlock="closed" />;
  if (reducedMotion) {
    return <LockOpenIcon width={size} height={size} aria-hidden data-padlock="open" />;
  }

  return (
    <motion.span
      style={{ display: 'inline-flex', transformOrigin: '50% 80%' }}
      initial={{ rotate: 0, y: 0 }}
      animate={{ rotate: [0, -16, 8, 0], y: [0, -2, 0, 0] }}
      transition={{ duration: UNLOCK_SETTLE_MS / 1000, ease: 'easeOut' }}
    >
      <LockOpenIcon width={size} height={size} aria-hidden data-padlock="open" />
    </motion.span>
  );
};
